import { render, staticRenderFns } from "./SidebarResults.vue?vue&type=template&id=487800b0"
import script from "./SidebarResults.vue?vue&type=script&lang=js"
export * from "./SidebarResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports